// import { Text } from '@pancakeswap-libs/uikit'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  padding: 20px 15px;
`

export const CopyIcon = styled.img<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`
export const Name = styled.div`
  color: #311765;
  font-size: 15px;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: center;
  &.active{
    color: #1EC7D3;
  }
`
export const Desc = styled.div`
  color: #7A6EAA;
  font-size: 13px;
  text-align: center;
  &.address{
    flex: 1;
    margin-right: 10px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
  }
`
export const NoMore = styled.div`
  padding: 50px 0;
  font-size: 16px;
  color: #BDC2C4;
  text-align: center;
`

